import React, { useState } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ReferalCard } from "@/components/ReferalCard/ReferalCard";
import { useReferalsStateStore } from "@/store/referalsStateStore";
import { Pagination } from "@/ui/Pagination/Pagination";
import classNames from "classnames";
import { dataTrigger } from "@/analytics";
import { useReferalsDataContext } from "@/store/ReferalsProvider";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import cls from "./styles.module.scss";

export const MissedReferals = () => {
  const { missedReferals, loadMissedReferals } = useReferalsDataContext();
  const missedReferalsList = missedReferals.results;
  const referalsPerPage = missedReferals.limit;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isOpen = useReferalsStateStore((s) => s.isMissedReferalsOpen);
  const setIsOpen = useReferalsStateStore((s) => s.setIsMissedReferalsOpen);

  const changePage = async (newPage: number) => {
    setIsLoading(true);

    setCurrentPage(newPage);
    const offset = (newPage - 1) * referalsPerPage;
    await loadMissedReferals(offset);

    setIsLoading(false);
  };

  if (!missedReferalsList || missedReferalsList.length === 0) return null;

  return (
    <FlexColumn gap={8}>
      <FlexRow
        justifyContent="space-between"
        className={cls.missedReferals}
        role="tab"
        {...dataTrigger("ref.referrals.missed")}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <FlexRow gap={10}>
          <Typography className={cls.missedReferalsTitle}>
            Упущенные рефералы
          </Typography>

          <div className={cls.refCount}>{missedReferals.count} чел.</div>
        </FlexRow>

        <div
          className={classNames(cls.toggleIcon, isOpen ? cls.open : undefined)}
        >
          ▾
        </div>
      </FlexRow>

      {isOpen && (
        <>
          <Typography className={cls.desc}>
            Зарегистрировались в парке более 28 дней назад, но не выполнили
            условия
          </Typography>

          {isLoading ? (
            <ContainerLoader />
          ) : (
            <FlexColumn gap={14} className={cls.missedReferalsList}>
              {missedReferalsList.map((elem) => (
                <ReferalCard
                  key={elem.telegram_user?.telegram_id}
                  referal={elem}
                />
              ))}
            </FlexColumn>
          )}

          <Pagination
            currentPage={currentPage}
            onPageChange={changePage}
            list={missedReferals}
          />
        </>
      )}
    </FlexColumn>
  );
};
